import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Address, CloseIcon } from 'components';

import './form-tile-header.scss';

export class FormTileHeader extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
    step: PropTypes.string,
    fixed: PropTypes.bool,
    massive: PropTypes.bool,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    children: null,
    title: '',
    step: '',
    fixed: false,
    massive: false,
  };

  render() {
    const { title, step, fixed, children, massive, address, onClose } =
      this.props;

    return (
      <div
        className={classnames('form-tile-header word-break', {
          _fixed: fixed,
        })}
      >
        {title && (
          <div
            className={classnames('form-tile-header__title montserrat', {
              _massive: massive,
            })}
          >
            <div className="flex justify-content-space-between align-items-flex-end">
              <div
                className="form-tile-header__title-name"
                dangerouslySetInnerHTML={{
                  __html: title
                    .replace(/<(\/)?script>/gi, '&lt;script&gt;')
                    .replace(
                      '(optional)',
                      '<span class="_optional">(optional)</span>',
                    ),
                }}
              />
              {step && <div className="form-tile-header__step">{step}</div>}
            </div>
            {address && <Address address={address} className="mt-2" />}
          </div>
        )}
        {onClose && (
          <CloseIcon
            width={15}
            height={15}
            className="form-tile-header__close"
            onClick={onClose}
            tabIndex={0}
          />
        )}
        {children}
      </div>
    );
  }
}

FormTileHeader.displayName = 'FormTileHeader';
